// @ts-nocheck

import { downloadRequestWithToken, fetchRequest } from './index';
/**
 * Получение отчета
 */
export const fetchReportFuelCards = async params => {
  return await fetchRequest.get('/report/fuelCard', {
    ...params
  });
};

/**
 * Печать отчета
 */
export const printReportFuelCards = async params => {
  const isPrinted = await downloadRequestWithToken('/report/fuelCard/print', {
    ...params
  });
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};
export default {
  fetchReportFuelCards,
  printReportFuelCards
};
